export const slug = (str: string) =>
  // IE 11 doesn't support normalize
  (str.normalize?.('NFD') || str)
    .toLowerCase()
    .replace(/[\u0300-\u036F]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/ /g, '-');
